import * as Sentry from "@sentry/react";
import {STORE_LANGUAGES as M2_STOTE} from "../../../constants/storeCode";
import api from "../../../services/api";
import apiAdyen from "../../../services/apiAdyen";

export const getDefaultConfigAdyen = (globalState, config) => {
    try {
        const {groupOrder, checkout} = globalState;
        const {configs, store} = groupOrder;
        let locate = 'en-US';

        if (M2_STOTE[store.id] ?? null) {
            locate = M2_STOTE[store.id] + '-' + M2_STOTE[store.id].toUpperCase();
        }

        return {
            environment: configs.adyen_env,
            clientKey: configs.public_adyen_token,
            paymentMethodsResponse: checkout.payment_methods_adyen.paymentMethodsResponse,
            locale: locate,
            ...config
        };
    } catch (e) {
        Sentry.captureException(e);
    }
}

export const checkPaymentStatusAdyen = async (orderId) => {
    let formData = new FormData();
    formData.append('order_id', orderId);

    let response = await api.post(
        `/calcuso-group-order/adyen/orders/payment-status`,
        {},
        formData
    );

    return JSON.parse(response.data);
}


export const checkPaymentDetailsAdyen = async (globalState, paymentData) => {
    const {groupOrder} = globalState;
    const {configs} = groupOrder;

    return await apiAdyen.post(
        `/checkoutshopper/services/PaymentInitiation/v1/status`,
        {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
        },
        {
            paymentData: paymentData
        }, {
            'clientKey': configs.public_adyen_token
        }
    );
}
